// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { citizenAppealsManifest } from './citizen-appeals';
import { petitionsManifest } from './petitions';
import { receptionHoursManifest } from './reception-hours';
import { regionalVisitsManifest } from './regional-visits';
import { voterGroupsManifest } from './voter-groups';

/** Група модулів «Виборці» (Constituents): 5 модулів. */
export const constituentsGroup: IModuleGroupManifest = {
  key: 'constituents',
  category: 'Constituents',
  name: { en: 'Constituents', uk: 'Виборці' },
  sort: 15,
  modules: [citizenAppealsManifest, petitionsManifest, receptionHoursManifest, regionalVisitsManifest, voterGroupsManifest],
};
